import React from 'react';

import { QueryClientProvider } from '@tanstack/react-query';
import PropTypes from 'prop-types';
import queryClient from 'react-query-settings/queryClient';

import AppWrapper from 'components/apps/AppWrapper';
import FolderInputSelect from 'components/projectForm/FolderInputSelect';

import { resourceShape } from 'components/helpers/serialisableResources';

export default function FolderInputSelectWrapper({
  contextProps,
  wrappedProps,
}) {
  return (
    <AppWrapper {...contextProps}>
      <QueryClientProvider client={queryClient}>
        <FolderInputSelect {...wrappedProps} />
      </QueryClientProvider>
    </AppWrapper>
  );
}

FolderInputSelectWrapper.propTypes = {
  wrappedProps: PropTypes.shape({
    domainFolder: resourceShape('folder'),
  }),
};
